"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineGuards = void 0;
/**
 * Returns combine guard from input guards as a result type is union type of guarded types
 * Its good for array filtering base on multiple guards and its return correct result union type
 *
 * @internal
 */
function combineGuards() {
    var guards = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        guards[_i] = arguments[_i];
    }
    return (function (x) { return (x ? guards.some(function (f) { return f(x); }) : false); });
}
exports.combineGuards = combineGuards;
//# sourceMappingURL=typesUtils.js.map